import React, { useState, useEffect } from "react";
import PatnerForm from "./form";
import Datatables from "../../../utils/table/datatable";
import { PATNERS } from "helpers/url_helper";
import { get } from "helpers/api_helper";
import { Link } from "react-router-dom";
import { showSuccessAlert } from "helpers/alert_helper";

const Patners = () => {
    const [ isForm , setIsForm ] = useState(false);
    const [ patnersList , setPatnersList ] = useState([]);
    const [ singleData , setSingleData ] = useState(null);
    const [ pagination, setPagination ] = useState({
        page: 1,
        limit: 10,
        search: '',
    })

    const toggleForm = () => {
        setIsForm(!isForm);
        if(isForm == false){
            setSingleData(null);
        }
        getPatnersList();
    }

    const getPatnersList = async () => {
        const { success, data } = await get(`${PATNERS}?limit=${pagination.limit}&page=${pagination.page}&search=${pagination.search}`);
        if(success){
            setPatnersList(data);
        }
    }

    useEffect(() => {
        const fetchData = setTimeout(() => {
            getPatnersList();
        }, 500);

        return () => clearTimeout(fetchData);
    }, [pagination.page, pagination.limit, pagination.search]);

    const handleEdit = async (id) => {
        const { success, data} = await get(`${PATNERS}/${id}`);
        if(success) {
            setSingleData(data);
            setIsForm(true);
        }
    }

    const handleRemove = async (id, sts) => {
        const { success, data} = await get(`${PATNERS}/${id}?status=${sts}`);
        if(success) {
            showSuccessAlert(`Patner ${ sts == 1? "deleted": "re-stored" } successfully`);
            getPatnersList();
        }
    }

    const PatnerColumns = [
        {
            dataField: 'id',
            text: '#'
        }, {
            dataField: 'name',
            text: 'Name'
        }, {
            dataField: 'phone',
            text: 'Phone Number'
        }, {
            dataField: 'actions',
            text: "",
            isDummyField: true,
            formatter: (cell, row) => <>
                <Link to="#" className="btn btn-outline-secondary btn-sm edit" onClick={() => handleEdit(row.id, row.status)} title="Edit" ><i className={`fas fa-pencil-alt`} /></Link>
                {" "}
                <Link to="#" className={`btn btn-${row.status == 0 ? "danger" : "success"} btn-sm edit`} onClick={() => handleRemove(row.id, row.status == 1 ? 0 : 1, row.code)} title={row.status == 0 ? 'delete' : 'restore'} ><i className={`fas fas fa-trash-alt`} /></Link>
            </>
        }
    ];

    return (
        isForm ? <PatnerForm cb={toggleForm} data={singleData} /> :
            <Datatables 
                isSearch={true}
                columns = {PatnerColumns}
                showTableOnly={true}
                rowsLength={patnersList?.totalRows || 0}
                rows = {patnersList?.data || []}
                keyField={'id'}
                handleAddButton={toggleForm}            
                title = "All Patners"
                loading = {false}
                isAdd = {true}
                isTableHead = {true}
                ssr={(page) => setPagination(page)}
            />
    );
};

export default Patners;